import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// All requests carry the HttpOnly session cookie (user + admin) automatically.
// No localStorage tokens — that closes the XSS token-theft window entirely.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Kept as an exported constant for backwards-compat with any dev tools scripts
// that may still reference it. No longer used inside the app.
export const ADMIN_TOKEN_KEY = "nobsgs_admin_token";

export const publicApi = {
  listCards: (params = {}) => api.get("/cards", { params }).then((r) => r.data),
  searchCards: (q, tag) =>
    api.get("/cards/search", { params: { q, tag } }).then((r) => r.data),
  trending: () => api.get("/cards/trending").then((r) => r.data),
  gazette: () => api.get("/gazette").then((r) => r.data),
};

export const authApi = {
  me: () => api.get("/auth/me").then((r) => r.data),
  createSession: (session_id) =>
    api.post("/auth/session", { session_id }).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};

export const userApi = {
  listBookmarks: () => api.get("/bookmarks").then((r) => r.data),
  addBookmark: (id) => api.post(`/bookmarks/${id}`).then((r) => r.data),
  removeBookmark: (id) => api.delete(`/bookmarks/${id}`).then((r) => r.data),
  submitFeedback: (body) => api.post("/feedback", body).then((r) => r.data),
  quizAttempt: (body) => api.post("/quiz/attempt", body).then((r) => r.data),
  // Log that the current user has swiped past a card. Fire-and-forget:
  // swallow errors so a slow network never blocks the scroll UX.
  markCardRead: (card_id) =>
    api.post("/cards/read", { card_id }).then((r) => r.data).catch(() => null),
};

export const adminApi = {
  login: (email, password) =>
    api.post("/admin/login", { email, password }).then((r) => r.data),
  logout: () => api.post("/admin/logout").then((r) => r.data),
  me: () => api.get("/admin/me").then((r) => r.data),
  updateCredentials: (body) => api.post("/admin/update-credentials", body).then((r) => r.data),
  // Cheap probe used by the dashboard to detect a live admin session without
  // pulling all data. 401 = not signed in, 200 = signed in.
  ping: () => api.get("/admin/stats").then((r) => r.data),
  listCards: (params = {}) => api.get("/admin/cards", { params }).then((r) => r.data),
  createCard: (card) => api.post("/admin/cards", card).then((r) => r.data),
  updateCard: (id, card) => api.put(`/admin/cards/${id}`, card).then((r) => r.data),
  deleteCard: (id) => api.delete(`/admin/cards/${id}`).then((r) => r.data),
  publishCard: (id) => api.post(`/admin/cards/${id}/publish`).then((r) => r.data),
  unpublishCard: (id) => api.post(`/admin/cards/${id}/unpublish`).then((r) => r.data),
  listGazette: () => api.get("/admin/gazette").then((r) => r.data),
  createGazette: (p) => api.post("/admin/gazette", p).then((r) => r.data),
  updateGazette: (id, p) => api.put(`/admin/gazette/${id}`, p).then((r) => r.data),
  deleteGazette: (id) => api.delete(`/admin/gazette/${id}`).then((r) => r.data),
  feedback: () => api.get("/admin/feedback").then((r) => r.data),
  stats: () => api.get("/admin/stats").then((r) => r.data),
  audit: () => api.get("/admin/audit").then((r) => r.data),
  listApiKeys: () => api.get("/admin/api-keys").then((r) => r.data),
  createApiKey: (label) => api.post("/admin/api-keys", { label }).then((r) => r.data),
  revokeApiKey: (key_id) => api.delete(`/admin/api-keys/${key_id}`).then((r) => r.data),
};
